import { rest } from 'lodash';
import React from 'react';
import { Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Logo = ({ ...rest }) => {

  const themeState = useSelector(state => state.themeState);

  return (
    <div>
      <Image
        src={themeState.themeMode === 'dark' ? '/assets/images/premier-nexus-logo-dark.png' : '/assets/images/premier-nexus-logo.png'}
        alt="Logo"
        className='nx-logo'
      />
    </div>
  );
};

export default Logo;
// premier-nexus-logo